<ngx-loading-bar
  [color]="'#7366ff'"
  [includeSpinner]="false"
  [height]="'5px'"
  [includeBar]="true"
  id="app-loading-bar"
></ngx-loading-bar>
<app-loader *ngIf="isLoading$ | async"></app-loader>
<app-navbar></app-navbar>
<router-outlet></router-outlet>
<app-footer></app-footer>
<app-msgbox></app-msgbox>
<app-notify></app-notify>
<ai-content-generator></ai-content-generator>
